import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "./fordon";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Cookiepolicy – AK Husbil & Fritid" },
      {
        name: "description",
        content:
          "Information om hur AK Husbil & Fritid använder cookies för funktion, analys och annonser via Google AdSense.",
      },
      { property: "og:title", content: "Cookiepolicy – AK Husbil & Fritid" },
      {
        property: "og:description",
        content: "Cookies vi använder för funktion, analys och annonser. Hantera dina val.",
      },
      { property: "og:url", content: "https://www.akhusbilfritid.se/cookies" },
    ],
    links: [{ rel: "canonical", href: "https://www.akhusbilfritid.se/cookies" }],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <>
      <PageHeader
        label="Juridik · Cookies"
        title={<>Om <span className="font-italic-display text-accent">cookies</span>.</>}
        sub="En cookie är en liten textfil som webbplatsen sparar i din webbläsare. Här ser du vad vi använder dem till."
      />

      <article className="container-edge max-w-3xl py-16 md:py-20">
        <p className="text-sm text-muted-foreground">Senast uppdaterad: {new Date().toLocaleDateString("sv-SE")}</p>

        <div className="mt-10 space-y-10">
          <Block
            h="Nödvändiga cookies"
            p="Krävs för att webbplatsen ska fungera, t.ex. sessions- och säkerhetscookies. Dessa kan inte stängas av."
          />
          <Block
            h="Analys"
            p="Hjälper oss förstå hur sidan används så vi kan förbättra innehåll och prestanda. Aggregerade och anonymiserade data."
          />
          <Block
            h="Annonser – Google AdSense"
            p="Google och dess partners använder cookies för att visa annonser baserat på dina besök här och på andra webbplatser. Du kan välja bort personaliserade annonser via Googles annonsinställningar."
            links={[
              { href: "https://www.google.com/settings/ads", label: "Googles annonsinställningar" },
              { href: "https://policies.google.com/technologies/ads", label: "Googles annonspolicy" },
              { href: "https://www.aboutads.info/choices/", label: "aboutads.info – välj bort" },
            ]}
          />
          <Block
            h="Hantera cookies i webbläsaren"
            p="Du kan själv blockera eller radera cookies via inställningarna i din webbläsare (Chrome, Safari, Firefox, Edge). Notera att vissa funktioner kan sluta fungera."
          />
        </div>

        <p className="mt-12 text-foreground/85">
          Läs även vår fullständiga <a href="/integritetspolicy" className="text-accent underline-offset-4 hover:underline">integritetspolicy</a>.
        </p>
      </article>
    </>
  );
}

function Block({ h, p, links }: { h: string; p: string; links?: { href: string; label: string }[] }) {
  return (
    <section>
      <h2 className="font-display text-2xl md:text-3xl">{h}</h2>
      <p className="mt-3 text-foreground/85">{p}</p>
      {links && (
        <ul className="mt-3 space-y-1.5 text-sm">
          {links.map((l) => (
            <li key={l.href}>
              <a href={l.href} target="_blank" rel="noopener noreferrer" className="text-accent underline-offset-4 hover:underline">
                {l.label} →
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
